export default {
  CUSTOMER: 'CUSTOMER',
};
